<template>
	<div>
		<!-- 子路由出口：用于显示订单详情等子页面 -->
		<router-view v-if="$route.path.includes('orderDatails')"></router-view>
		<!-- 订单列表：当不在详情页时显示 -->
		<template v-else>
			<div class="navlist">
				<ul>
					<li v-for="(i,Index) in navlist"
					  :key='index'
					  :class="{'classType':Index==navindex}" 
					   @click="tobnav(Index)"
					>
					{{i.name}}
					<div v-if="Index==navindex"></div>
					</li>
				</ul>
				<div class="navso">
					<div class="soinput">
					  <i class="el-icon-search"></i>
					  <input type="text" placeholder="请输入您要搜索的内容" v-model="keyword"> 
					</div>
					<button>搜索</button>
				</div>
			</div>
			<orderList :list="list"></orderList>
			<div class="fenye" v-if="total>12">
			   <el-pagination
				 background
				 @current-change="handleCurrentChange"
				 :current-page.sync="currentPage1"
				 :page-size="100"
				 layout="total, prev, pager, next ,jumper"
				 :total="total">
			   </el-pagination>
			</div>
		</template>
	</div>
</template>

<script>
	import {
		OrderIndex
	} from "@/api/api.js"
	import orderList from '@/common/orderList.vue';
	export default {
	  name: 'HelloWorld',
	  components:{
		 orderList  
	  },
	  data() {
	    return {
		   currentPage1:"",
		   keyword:"",
		   navindex:0,
		   navlist:[
			   {name:"全部"},
			   {name:"待付款"},
			   {name:"进行中"},
			   {name:"待评价"},
			   {name:"已完成"},
			   {name:"已取消"}
		   ],
		   page:1,
		   status:"",
		   score:"",
		   list:[]
	    }
	  },
	  created() {
	  	this.getOrderIndex()
	  },
	  methods: {
		getOrderIndex(){
		  	OrderIndex({
		  		status:this.status,
		  		keyword:this.keyword,
		  		page:this.page,
		  		limit:'12',
		  		score:this.score
		  	}).then(res=>{
		  		this.list=res.data.data.data
				this.total=res.data.data.total
				this.pagecount=res.data.data.pass_count
				this.currentPage1=res.data.data.current_page
		  	})
		},
		handleCurrentChange(e){
			this.page=e
			this.getOrderIndex()
		},
		tobnav(index){
			this.navindex=index
			switch(this.navindex) {
			    case 0:
			        this.status = "";
					 this.score = ""
			        break;
			    case 1:
			        this.status = "0";
					 this.score = ""
			        break;
			    case 2:
			        this.status = "1,2,3,4";
					 this.score = ""
			        break;
			    case 3:
			        this.status = "5";
			        this.score = 0;
			        break;
			    case 4:
			        this.status = "5";
			        this.score = "1";
			        break;
			    case 5:
			        this.status = "-1";
			        this.score = "";
			        break;
			}
			this.page=1
			this.getOrderIndex()
		}
	  },
	}
</script>

<style scoped>
	.navlist{
		width:1200px;
		margin:0 auto;
		height: 48px;
		background: #FFFFFF;
		border-radius: 12px;
		margin-top:24px;
		margin-bottom:24px;
		padding:8px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.navlist ul{
		display:flex;
		align-items:center;
	}
	.navlist li{
		margin-right:16px;
		font-weight: 400;
		font-size: 14px;
		color: #666666;
		cursor:pointer;
	}
	.navso{
		width: 360px;
		height: 32px;
		background: #FFFFFF;
		border-radius: 12px;
		border: 1px solid #1E3A8A;
		padding: 7px 8px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.soinput{
		display:flex;
		align-items:center;
	}
	.navso input{
		width:270px;
		border:none;
		outline:none;
		margin-left:5px;
	}
	.navso button{
		width: 40px;
		height: 24px;
		background: #1E3A8A;
		border-radius: 6px;
		color:#fff;
		border:none;
		outline: none;
		font-weight: 400;
		font-size: 12px;
		cursor: pointer;
	}
	.fenye{
		width:100%;
		display:flex;
		justify-content:center;
		align-items: center;
		padding-bottom:60px;
	}
	.classType{
		font-weight: bold !important;
		font-size: 32rpx !important;
		color: #1E3A8A !important;
	}
	.classType div{
		position:absolute;
		width: 48rpx;
		height: 6rpx;
		background: #1E3A8A;
		border-radius: 24rpx;
		bottom: 0;
		margin-bottom:-24rpx;
		left: 50%;
		margin-left:-24rpx;
	}
	.demandlist{
		width:100%;
		padding:0rpx 24rpx 24rpx;
		box-sizing: border-box;
	}
</style>